import React, { useState, useEffect } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from './styles'
import { Container, Grid } from '@material-ui/core'
import EvaluatorModal from '../../components/EvaluatorModal'
import NextSetModal from '../../components/NextSetModal'
import FirstModal from '../../components/FirstModal'
import SecondModal from '../../components/SecondModal'
import ThirdModal from '../../components/ThirdModal'
import FinalModal from '../../components/FinalModal'
import PlayQuiz from '../../components/PlayQuiz'
import { isMobileOnly } from 'react-device-detect'
import questionSets from './questionAnswers'
import { mobileScreen } from "../../utils/styleUtils"
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MCQS from '../../components/MCQS'

const Titles = ["IN THE LABOR FORCE?", "EMPLOYED?"]

const QuizScreen = ({ classes, setCurrentScreen, givenAnswers, setGivenAnswers }) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(mobileScreen(theme));

  const [dragStarted, setDragStarted] = useState(false)
  const [answers, setAnswers] = useState([])
  const [questions, setQuestions] = useState(questionSets[0])

  // const [givenAnswers, setGivenAnswers] = useState([])
  const [prevAnswer, setPrevAnswer] = useState(false)
  const [answeredCorrectly, setAnsweredCorrectly] = useState(null)
  const [openEvaluatorModal, setOpenEvaluatorModal] = useState(false)
  const [questionIndex, setQuestionIndex] = useState(0)
  const [questionSetIndex, setQuestionSetIndex] = useState(0)
  const [animationFinished, setAnimationFinished] = useState(false)
  const [openNextSetModal, setOpenNextSetModal] = useState(false)
  const [moveBack, setMoveBack] = useState(false); 
  const [reset, setReset] = useState(false)
  const [openFirstModal, setOpenFirstModal] = useState(questionSetIndex===0 && questionIndex === 0)
  const [openSecondModal, setOpenSecondModal] = useState(questionSetIndex===1 && questionIndex === 0)
  const [openThirdModal, setOpenThirdModal] = useState(questionSetIndex===2 && questionIndex === 0)
  const [openFinalModal, setOpenFinalModal] = useState(questionSetIndex===3 && questionIndex === 0)
  const [showQuestion, setShowQuestion] = useState(true)

  const onSubmit = (newAnswer) => {
    setOpenEvaluatorModal(newAnswer)
  }

  const nextQuestion = () => {
    setShowQuestion(false)
    setPrevAnswer(openEvaluatorModal)
    // setPrevAnswer(null)
    setOpenEvaluatorModal(null)
    setGivenAnswers([...givenAnswers, answeredCorrectly])
    if (questionIndex >= questions.length - 1){
      setCurrentScreen("Result")
    }
    else{
      setAnswers([...answers, questions[questionIndex]])
      setQuestionIndex(questionIndex + 1)
      setShowQuestion(true)
    }
    // if (questionIndex >= questions.length - 1)
    //   if(questionSetIndex >= questionSets.length - 1) {
    //     setOpenFinalModal(true)
    //     // setCurrentScreen("Result")
    //   } else {
    //     handleNextSet()
    //     setAnswers([...answers, questions[questionIndex]])
    //   }
    // else {
    //   setAnswers([...answers, questions[questionIndex]])
    //   setQuestionIndex(questionIndex + 1)
    //   setShowQuestion(true)
    // }
    setReset(!reset)
  }

  useEffect(() => {
    console.log("in useeffect", answers.length)
  }, [answers])

  const handleNextSet = () => {
    if(questionSetIndex === 1){
      setAnswers([])
      setQuestionIndex(0)
      setQuestions(questionSets[questionSetIndex + 1])
      setQuestionSetIndex(questionSetIndex + 1)
      return
    }
    // setOpenNextSetModal(false)
    setTimeout(() => {
      setMoveBack(true)
      setQuestionIndex(0)
      setQuestions(questionSets[questionSetIndex + 1])
    }, 500);
  }

  useEffect(() => {
    if(animationFinished){
      // setQuestions(questionSets[questionSetIndex + 1])
      // setQuestionIndex(0)
      setTimeout(() => {
        setMoveBack(false)
        setAnswers([])
        setAnimationFinished(false)
        setShowQuestion(true)
        setQuestionSetIndex(questionSetIndex + 1)
      }, 1000);
    }
  }, [animationFinished])

  useEffect(() => {
    setTimeout(() => {
      if(questionSetIndex === 1){
        setOpenSecondModal(true)
      }
    }, 1500);
    if(questionSetIndex === 2){
      setOpenThirdModal(true)
    }
  }, [questionSetIndex])

  useEffect(() => {
    setTimeout(() => {
      setAnsweredCorrectly(null)
      console.log("AnsweredCorrectly", answeredCorrectly)
      setPrevAnswer(null)
    }, 1000)
  }, [questionIndex])

  console.log("AnsweredCorrectly", answeredCorrectly)
  return (
    <Grid>
      <Grid className={`${classes.quizScreenContainer} ${dragStarted && 'overlay'}`}>
        <Container maxWidth={isMobile ? 'sm' : 'md' } style={{ paddingTop: isMobile ? '0.5rem' : '2rem' }}>
          {questionSetIndex < 2 ? <PlayQuiz
            title={Titles[questionSetIndex]}
            dragStarted={dragStarted}
            setDragStarted={setDragStarted}
            onSubmit={onSubmit}
            currentQuestion={questions[questionIndex]}
            prevQuestion={questionIndex > 0 && questions[questionIndex - 1]}
            prevAnswer={prevAnswer}
            answers={answers}
            setAnsweredCorrectly={setAnsweredCorrectly}
            answeredCorrectly={answeredCorrectly}
            isEvaluatorModalOpen={openEvaluatorModal}
            key={reset}
            moveBack={moveBack}
            openNextSetModal={openNextSetModal}
            questionSetIndex={questionSetIndex}
            setAnimationFinished={setAnimationFinished}
            showQuestion={showQuestion}
            setShowQuestion={setShowQuestion}
          />
          : <MCQS
            setAnsweredCorrectly={setAnsweredCorrectly}
            currentQuestion={questions[questionIndex]}
            onSubmit={onSubmit}
          />
          }
        </Container>
      </Grid>
      <FirstModal isOpen={openFirstModal} handleClose={() => setOpenFirstModal(false)} />
      {/* {openNextSetModal && <NextSetModal questionSetIndex={questionSetIndex} handleNextSet={handleNextSet} />} */}
      {/* <SecondModal isOpen={openSecondModal} handleClose={() => setOpenSecondModal(false)} />
      <ThirdModal isOpen={openThirdModal} handleClose={() => setOpenThirdModal(false)} />
      <FinalModal isOpen={openFinalModal} handleClose={() => setCurrentScreen("Result")} /> */}
      {openEvaluatorModal && <EvaluatorModal questionSetIndex={questionSetIndex} nextQuestion={nextQuestion} question={questions[questionIndex]} answeredCorrectly={answeredCorrectly}/>}
    </Grid>
  )
}

export default withStyles(styles)(QuizScreen)
